export const COMMISION = 0.05;

const errorPrice = {
  total: 0,
  commision: 0
};

const getUserComission = ({ amount, commision, user }) => {
  console.log(amount, commision, user);
  return {
    total: 0,
    commision: 0
  };
};

export const getComission = ({ amount, commission = null, user = null }) => {
  const commissionValue = typeof commision === 'number' ? commission : COMMISION;

  if (!amount) return errorPrice;
  if (user) return getUserComission({ amount, commision: commissionValue, user });

  const commissionAmount = amount * commissionValue;
  const totalAmount = amount + commissionAmount;

  return {
    total: totalAmount,
    commission: commissionAmount
  };
};
